import { Component,OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import { OrderPlacePage} from'../orderplace/orderplace';
import {FormGroup,FormControl } from '@angular/forms';
import {PaymentPage} from '../payment/payment';
import { AlertController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { Device } from '@ionic-native/device';
import { LoadingController } from 'ionic-angular';

@Component({
	selector: 'page-delivery',
	templateUrl: 'delivery.html',
	providers:[MydataService,MyUrlService,JsonData,Device]
	
})

export class DeliveryPage implements OnInit {
	jsonDt : Array<JsonData>;
	userdataDt: Array<JsonData>;
	//address=this.address = window.localStorage.setItem('address',address););
	selectItem:string;
	langs;
	langForm;
	local:string;
	deliveryCharge: any;
	takeawayMinValue:any;
	minOrderValue:any;
	deliverych:any;
	constructor(public loading: LoadingController,public navCtrl: NavController,public alerCtrl: AlertController,public device: Device,private http:Http,private mydataService: MydataService,private myurlService: MyUrlService) {
		
	    this.langForm = new FormGroup({
			"langs": new FormControl({value: 'rust', disabled: false})
		});
	}
	
	ngOnInit(){
		if(this.mydataService.checkInternetFunction()=="0"){
			//console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1") {
			
			var userid = window.localStorage.getItem('userid');
			
			var kiloSabjiJSONdata = JSON.stringify({'userid': userid});
			console.log("Product Url--->" + this.myurlService.USERADDRESS + "\n" + "JSON Parameter--->" + kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			//this.mydataService.postJSON(this.myurlService.PRODUCTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => console.log(error),() =>this.hello(loader));
			
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.USERADDRESS, kiloSabjiJSONdata).subscribe(data => this.jsonDt = data, error => this.errorFunction(loader,error), () => this.deliveryService(loader));
			});
			
		}  }
		
		errorFunction= function(loader,error){
			loader.dismiss();
			console.log(error);
			//alert(error);
		}
		deliveryService=function(loader){
			//console.log("product receive jsondata ==>"+JSON.stringify(this.jsonDt.productdata));
			
			this.userdataDt = this.jsonDt.userdata;
			console.log("aaaaaaaaaaaaaaaa===>"+JSON.stringify(this.jsonDt));
			this.areanamedata = this.jsonDt.areanamedata;
			this.minOrderValue = this.jsonDt.orderconfig[0].minOrderValue;
			this.deliverych	 = this.jsonDt.orderconfig[0].deliverycharge;
			this.takeawayMinValue = this.jsonDt.orderconfig[0].takeawayMinValue;
			this.takeawayDiscount = this.jsonDt.orderconfig[0].takeawayDiscount;
			
			//alert("chearge===>"+JSON.stringify(this.jsonDt.areanamedata));
			console.log("userdetial ==>"+JSON.stringify(this.jsonDt.userdata));
			loader.dismiss();
		}
		
		selectDeliveryArea()
		{
			let selectAreaChange = this.local;
			if(selectAreaChange=="Other"){
				this.deliveryCharge=this.deliverych;
				}else{
				this.deliveryCharge='0';
			}
			
		}
		
		selectionAny(selecItem){
			//	 alert("work--->"+selecItem);
			this.selectItem = selecItem;
			window.localStorage.setItem('selectDeliveryType',this.selectItem);
		}
		doSubmit(event,name,mobileNo,city,address) {
			//alert(address);
			//alert(myVal);
			window.localStorage.setItem('name',name);
			window.localStorage.setItem('mobileno',mobileNo);
			window.localStorage.setItem('address',address);
			window.localStorage.setItem('city',city);
			//alert("ddadasdsa====>"+areaaa);
			
			let selectArea = this.local;
			//alert("other selectArea===>"+otherArea);
			/*if(selectArea=="Other"){
				this.showother = "1";
				}else{
				this.showother = "0";
				}
			*/
			//console.log('Submitting form', this.langForm.value);
			//	alert(JSON.stringify(this.langForm.value)+"select item---"+this.selectItem+"---      "+"addrssess   "+this.address);
			//alert(address+"  "+this.selectItem);
			if((selectArea==null || selectArea=="Select area")&& this.selectItem!='Take Away'){
				this.showAlert("Please select area");
			}else
			if(address=='')
			{
				this.showAlert("Please select delivery option and address");
			}else if(this.selectItem==null)
			{
				this.showAlert("Please select delivery option and address");
				}else{
				if(selectArea=="Other"){
					
					window.localStorage.setItem('selectItem',this.selectItem);
					window.localStorage.setItem('selectArea',selectArea);
					//alert(window.localStorage.getItem('selectItem')+"           "+		window.localStorage.getItem('selectArea'))
					
					//alert("this.selectItem===>"+this.selectItem);
					if(this.selectItem=='Take Away'){
						//alert("this.selectIte   115  m===>"+this.selectItem);
						window.localStorage.setItem('deliveryCharge','0');
						}else{
						window.localStorage.setItem('deliveryCharge',this.deliveryCharge);
					}
					//	alert("this.selectIte   115 dfvfd m===>"+this.selectItem);
					this.checkSelectItem(this.selectItem);
					
					
					}else{
					window.localStorage.setItem('selectItem',this.selectItem);
					window.localStorage.setItem('deliveryCharge',"0");
					
					window.localStorage.setItem('selectArea',selectArea);
					//alert(window.localStorage.getItem('selectArea'))
					//alert("this.selectIte   115  m===>"+this.selectItem);
					this.checkSelectItem(this.selectItem);
				}
			}
		}
		/*	onchange(changedval){
			//alert(changedval);
			if(changedval=="Other"){
			this.showother = "1";
			}else{
			this.showother = "0";
			}
		}*/
		checkSelectItem=function(selectDeliveryOption) {
			//alert("0 "+selectDeliveryOption);
			//alert('check  '+window.localStorage.getItem('showTotalAmt'))
			if(selectDeliveryOption=='Take Away'){
			//alert("1 "+selectDeliveryOption +"           "+window.localStorage.getItem('showTotalAmt')+"       "+this.minOrderValue);
				if(parseInt(window.localStorage.getItem('showTotalAmt'))>=parseInt(this.takeawayMinValue)){
					window.localStorage.setItem('deliveryAmountVali',this.takeawayMinValue)
				//alert("2 "+selectDeliveryOption);
					//event.preventDefault();
					this.checkProductAvail();
					//this.navCtrl.push(PaymentPage);
					}else{
					this.showAlert("Please make sure your cart order is more than a Gross Value of Rs. "+this.takeawayMinValue);
				}}else if(selectDeliveryOption=='Doorstep Delivery'){
				//alert("3 "+selectDeliveryOption+"           "+window.localStorage.getItem('showTotalAmt')+"       "+this.minOrderValue);
					if(parseInt(window.localStorage.getItem('showTotalAmt'))>=parseInt(this.minOrderValue)){
					//	alert("4 "+selectDeliveryOption);
					window.localStorage.setItem('deliveryAmountVali',this.minOrderValue)
						//event.preventDefault();
						this.checkProductAvail();
						//this.navCtrl.push(PaymentPage);
						}else{
					this.showAlert("Please make sure your cart order is more than a Gross Value of Rs. "+this.minOrderValue);
					}	
				}
			
		}
	
	checkProductAvail=function(){
		var kiloSabjiJSONdata = JSON.stringify({"deliverydate":window.localStorage.getItem('delDate'),"userid":window.localStorage.getItem('userid'),"IMEI":window.localStorage.getItem('session_ids')});
			//alert(this.myurlService.MYCARTCHECKOUTCAll +"           "+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.CHECKPRODUCTEXIST ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.AvailProduct(loader));
			});
		}
		
		AvailProduct=function(load){
				load.dismiss();
				//alert("chekk===>"+JSON.stringify(this.jsonDt))
				//alert("chekk msg===>"+JSON.stringify(this.jsonDt.msg))
				//alert("chekk===>"+JSON.stringify(this.jsonDt))
				if(this.jsonDt.msg==""){
					this.navCtrl.push(PaymentPage);
					}else{
						this.showAlert(this.jsonDt.msg);
					}
					
		}
	
		showAlert=function(infor) {
			let alert = this.alerCtrl.create({
				// title: 'New Friend!',
				subTitle: infor,
				buttons: ['OK']
			});
			alert.present();
			}
			/*delivery()
				{
				//alert(data);
			this.navCtrl.push(PaymentPage);
			
			} */
			userdetial()
			{
			this.navCtrl.push(OrderPlacePage);
		}
		
		
}



// WEBPACK FOOTER //
// ./src/pages/delivery/delivery.ts